'use strict';
/**
 * Test whether a value is a BigNumber
 * @param {*} x
 * @return {boolean}
 */

module.exports = function isBigNumber(x) {
  return x && x.constructor.prototype.isBigNumber || false;
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/utils/bignumber/isBigNumber.js
// module id = 274
// module chunks = 0